<div class="space-y-6">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-4">
      <button (click)="goBack()"
        class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
        Volver
      </button>
      <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Países</h1>
    </div>
    <button (click)="openCreateModal()"
      class="shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
      Nuevo País
    </button>
  </div>

  <app-data-table [columns]="columns" [rows]="countries()" [loading]="loading()" [searchTerm]="searchTerm"
    (search)="onSearch($event)" [page]="page" [pageSize]="pageSize" [totalCount]="totalCount"
    (pageChange)="onPageChange($event)" [stickyHeader]="true" searchPlaceholder="Buscar...">

    <ng-template tableCell="acciones" let-row>
      <div class="flex justify-end gap-2">
        <button (click)="openEditModal(row)"
          class="shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
          </svg>
          Editar
        </button>
        <button (click)="delete(row)"
          class="shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-red-300 bg-white px-3 py-2 text-sm font-medium text-red-700 transition hover:bg-red-50 dark:border-red-700 dark:bg-gray-800 dark:text-red-400 dark:hover:bg-red-900/20">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
          </svg>
          Eliminar
        </button>
      </div>
    </ng-template>
  </app-data-table>
</div>

<app-modal [open]="showModal()" [title]="editingItem() ? 'Editar País' : 'Nuevo País'" [hasCustomFooter]="true" (close)="closeModal()" size="md-1">
  <div modal-body>
    <form [formGroup]="form" class="space-y-4">
      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Nombre</label>
        <input type="text" formControlName="name"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          [class.border-red-500]="form.get('name')?.invalid && form.get('name')?.touched">
        @if (form.get('name')?.invalid && form.get('name')?.touched) {
          <p class="mt-1 text-sm text-red-600">El nombre es requerido</p>
        }
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Código ISO</label>
          <input type="text" formControlName="isoCode" maxlength="3"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
            [class.border-red-500]="form.get('isoCode')?.invalid && form.get('isoCode')?.touched">
          @if (form.get('isoCode')?.invalid && form.get('isoCode')?.touched) {
            <p class="mt-1 text-sm text-red-600">El código ISO es requerido</p>
          }
        </div>

        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Código de Marcado</label>
          <input type="text" formControlName="dialCode" maxlength="5"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
            [class.border-red-500]="form.get('dialCode')?.invalid && form.get('dialCode')?.touched">
          @if (form.get('dialCode')?.invalid && form.get('dialCode')?.touched) {
            <p class="mt-1 text-sm text-red-600">El código de marcado es requerido</p>
          }
        </div>
      </div>

      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Máscara de Teléfono</label>
        <input type="text" formControlName="phoneMask" placeholder="Ej: +57 (000) 000-0000"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          [class.border-red-500]="form.get('phoneMask')?.invalid && form.get('phoneMask')?.touched">
        @if (form.get('phoneMask')?.invalid && form.get('phoneMask')?.touched) {
          <p class="mt-1 text-sm text-red-600">La máscara de teléfono es requerida</p>
        }
      </div>

      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Ejemplo de Número</label>
        <input type="text" formControlName="phoneHolder" placeholder="Ej: +57 (300) 123-4567"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          [class.border-red-500]="form.get('phoneHolder')?.invalid && form.get('phoneHolder')?.touched">
        @if (form.get('phoneHolder')?.invalid && form.get('phoneHolder')?.touched) {
          <p class="mt-1 text-sm text-red-600">El ejemplo de número es requerido</p>
        }
      </div>
    </form>
  </div>
  <div modal-footer>
    <button type="button" (click)="closeModal()"
      class="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
      Cancelar
    </button>
    <button type="button" (click)="save()" [disabled]="form.invalid"
      class="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50">
      Guardar
    </button>
  </div>
</app-modal>

